// https://www.figma.com/file/mrdiByIw3khIMAh05RjAcL/002---PLX-UI-Library?type=design&node-id=51417-106094&mode=dev
import { Flex, FlexProps } from '@chakra-ui/react';
import { Background } from '@pluxee-design-system/core';
import { px, py } from 'common/layouts/layout.styles';
import { ReactNode } from 'react';

interface SplitScreenProps {
  isPortal?: boolean;
  children: ReactNode;
  gap?: FlexProps['gap'];
}

const SplitScreen = ({ children, gap }: SplitScreenProps) => (
  <Flex
    align={{ base: 'stretch', lg: 'flex-start' }}
    direction={{ base: 'column', lg: 'row' }}
    minWidth={0}
    overflow="auto"
    width="100%"
    bg="semantic.surface.1"
  >
    <Flex direction="column" flex="1 1 50%" gap={gap} align="stretch" py={py} px={px}>
      {children}
    </Flex>
    <Flex
      hideBelow="lg"
      direction="column"
      flex="1 1 50%"
      align="stretch"
      position="sticky"
      top="0"
      right="0"
      height="100%"
    >
      <Background variant="chevron" width="100%" height="100%" />
    </Flex>
  </Flex>
);

export default SplitScreen;
